// extracted by mini-css-extract-plugin
module.exports = {"container":"dd31006766--container--r1K4p","image":"dd31006766--image--N0Nnh"};